import type { BorrowerApi } from '@sg/api/borrower-api';

/** The settlement-term value that means "each row's own market default", not a T+n. */
export const MARKET_DEFAULT_SETTLEMENT_TERM_VALUE = 'MD';

export type SettlementTermChoice = number | typeof MARKET_DEFAULT_SETTLEMENT_TERM_VALUE;

// A term the row doesn't offer falls back to its market default, then its first date: the bulk booker's rule.
export function keyDateForTerm(
  keyDates: BorrowerApi.KeyDatesDto[],
  term: SettlementTermChoice
): BorrowerApi.KeyDatesDto | undefined {
  const marketDefault = keyDates.find((keyDate) => keyDate?.isMarketDefault);

  if (term === MARKET_DEFAULT_SETTLEMENT_TERM_VALUE && marketDefault) {
    return marketDefault;
  }

  return keyDates.find((keyDate) => keyDate?.settlementTerms === term) ?? marketDefault ?? keyDates[0];
}

export function settlementTermItems(terms: number[]): { value: SettlementTermChoice; label: string }[] {
  return [
    { value: MARKET_DEFAULT_SETTLEMENT_TERM_VALUE, label: 'Market Default' },
    ...[...new Set(terms)].sort((a, b) => a - b).map((term) => ({ value: term, label: `T+${term}` })),
  ];
}
